var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":"Medio Pago","items":_vm.mediosPagos,"item-text":"nombre","return-object":"","clearable":_vm.clearable},on:{"change":_vm.change},model:{value:(_vm.medioPago),callback:function ($$v) {_vm.medioPago=$$v},expression:"medioPago"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }